import { GetUser } from "@redotech/account-common/user";

/**
 * Datadog RUM user attributes attached to every RUM event (`@usr`).
 *
 * `role` uses the merchant's managed roles (admin, user, view-only, ...)
 * rather than the deprecated `roles` field or `userRoles` custom-role IDs,
 * which are raw ObjectIds and not readable in dashboards.
 */
export function rumUserAttributes(user: GetUser) {
  return {
    id: user._id,
    email: user.email,
    role: user.managedUserRoles ?? [],
    job: user.jobProfile?.job ?? [],
    level: user.jobProfile?.level,
  };
}
